import React, { Suspense, useEffect, useRef, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import {
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getRefFromId,
  listenDocDataByIdX,
} from "../models/DataFunctions";
import { useNavigate } from "react-router-dom";
import ParametersNavBar from "../hexagone/ParametersNavBar";
import { signInWithCustomToken } from "firebase/auth";
import { useSnackbar } from "notistack";
import { logoutUser, useAuth } from "../auth/FirebaseAuth";
import loginAs from "../api/loginAs";
import { useAppContext } from "./AppContext";
import { getOrRefreshFirebaseToken } from "./getFirebaseToken";
import Gleap from "gleap";
import startGleapSession from "../api/auth/startGleapSession";
import sendErrorDiscord from "../api/sendErrorDiscord";
import SecondaryButton from "../buttons/SecondaryButton";
import Icon1 from "../icons/Icon";
import NavBar from "../hexagone/NavBar";
import RoutesManager from "./RoutesManager";
import { auth } from "./FirebaseConfig";
import { isLight } from "../hexagone/VisibilityHelpers";
import { getOrgById } from "../models/OrgFunctions";
import { User } from "../types/user";
// import { User as FirebaseUser } from "../auth/FirebaseAuth";
import type { User as FirebaseUser } from "firebase/auth";
import { Org, Workspace } from "../types/org";
// Array of pages to show the NavBar

const App = () => {
  const location = useLocation();

  let x_pages = ["home", "carnet", "partner", "recharge", "parameters", "bibliotheque", "admin"];
  let portal_pages: string[] = [];
  const navigate = useNavigate();

  const getPageFromPath = (path: string) => {
    if (path.includes("/home")) {
      return "home";
    }

    if (path.includes("carnet")) {
      return "carnet";
    }
    if (path.includes("partner")) {
      return "partner";
    }

    if (path.includes("/partner")) {
      return "partner";
    }
    if (path.includes("/recharge")) {
      return "recharge";
    }
    if (path.includes("/parameters")) {
      return "parameters";
    }
    if (path.includes("/account")) {
      return "parameters";
    }
    if (path.includes("/tags")) {
      return "parameters";
    }
    if (path.includes("/organisation")) {
      return "parameters";
    }
    if (path.includes("/bibliotheque")) {
      return "bibliotheque";
    }
    if (path.includes("/admin")) {
      return "admin";
    }

    return "";
  };

  const actualpage: any = getPageFromPath(location.pathname);

  let isinside = x_pages.includes(actualpage);
  const { appState, setAppState, fetchCarnets, resetAppStateLogin } =
    useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const wsprefix = appState.dev
    ? "http://localhost:8081/"
    : "https://hexa-websockets-518651086100.europe-west9.run.app/";
  let isinsideportal = portal_pages.includes(actualpage);
  let isinparameters = actualpage === "parameters";
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (
    message: string,
    variant: "success" | "error" | "default" | "warning" | "info" | undefined
  ) => {
    enqueueSnackbar(message, { variant });
  };

  const {
    currentUser,
    loading,
  }: { currentUser: FirebaseUser | null; loading: boolean } = useAuth(); // add types
  const [userData, setUserData] = useState<User | null>(null);
  const [orgData, setOrgData] = useState<Org | null>(null);
  const [masterData, setMasterData] = useState<Org | null>(null);
  const [workspaceData, setWorkspaceData] = useState<Workspace | null>(null);

  const handleSetMasterData = (data: any) => {
    setMasterData(data);
  };

  const handleSetOrgData = (data: any) => {
    setOrgData(data);
  };

  const handleSetUserData = (data: any) => {
    setUserData(data);
  };

  const handleRefreshOrg = async () => {
    if (workspaceId()) {
      const workspace = (await getDocDataById(
        "workspace",
        workspaceId()
      )) as any as Workspace;
      setWorkspaceData(workspace);
      const master = (await getOrgById(workspace?.master_id)) as any as Org;
      await fetchCarnets(orgData);

      setMasterData(master);
    }
  };

  useEffect(() => {
    if (orgData) {
      handleRefreshOrg();
    }
  }, [workspaceId()]);

  const [errorMessage, setErrorMessage] = useState("");

  // We use `useState` to ensure the Connect instance is only initialized once

  const [workspaces, setWorkspaces] = useState<Workspace[]>([]);
  const [stripeConnectInstance, setStripeConnectInstance] = useState(null);

  // Track the intended destination when authenticating with authToken
  const [authTokenDestination, setAuthTokenDestination] = useState<string | null>(null);
  const [isAuthenticatingWithToken, setIsAuthenticatingWithToken] = useState(false);

  // Handle automatic login from authToken in URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authToken = urlParams.get('authToken');

    if (authToken && !currentUser && !loading && !isAuthenticatingWithToken) {
      console.log("🔐 Authenticating with authToken...");
      console.log("🎯 Intended destination:", location.pathname);

      // Store the intended destination BEFORE authentication
      setAuthTokenDestination(location.pathname);
      setIsAuthenticatingWithToken(true);

      signInWithCustomToken(auth, authToken)
        .then(() => {
          console.log("✅ Auto-login successful from authToken");
          // Clean up URL parameter
          window.history.replaceState({}, document.title, location.pathname);
        })
        .catch((error) => {
          console.error("❌ Auto-login failed:", error);
          handleClickVariant("Erreur d'authentification automatique", "error");
          setIsAuthenticatingWithToken(false);
          setAuthTokenDestination(null);
          // Remove authToken from URL on error
          window.history.replaceState({}, document.title, location.pathname);
        });
    }
  }, [currentUser, loading, isAuthenticatingWithToken]);

  const initializeGleapSession = async () => {
    Gleap.initialize("73u8YbffLxFHKrGDcGMMGaCEcg5sxYQc");
    Gleap.setLanguage("fr");
    const token = await getOrRefreshFirebaseToken();
    let data = await startGleapSession(token, prefix);
    if (data) {
      Gleap.identify(
        data.user_id,
        {
          name: data.name,
          email: data.email,

          phone: data.phone,
          value: data.value,
          plan: data.plan,
          companyId: data.companyId,
          companyName: data.companyName,
          // Passing the createdAt property allows you to set the correct createdAt date. (optional)
          createdAt: data.createdAt ? new Date(data.createdAt * 1000) : null,
          customData: {
            type: data.customData.type,
            master_id: data.customData.master_id,
            master_name: data.customData.master_name,
            master_email: data.customData.master_email,
          },
        },

        data.gleap_user_hash
      );
    }

    // 🔧 Wait for Gleap to inject itself, then fix pointer-events
    setTimeout(() => {
      const gleapIframe = document.querySelector('iframe[src*="gleap"]');
      if (gleapIframe) {
        (gleapIframe as HTMLIFrameElement).style.pointerEvents = "auto";
        (gleapIframe as HTMLIFrameElement).style.zIndex = "999999";
      }

      const gleapDivs = document.querySelectorAll('div[class*="gleap"]');
      gleapDivs.forEach((el) => {
        (el as HTMLElement).style.pointerEvents = "auto";
        (el as HTMLElement).style.zIndex = "999999";
      });
    }, 1000); // 1 second is usually safe, tweak if needed
  };

  const handleFetchData = async (
    currentUser: FirebaseUser,
    override_id: string | null
  ) => {
    Gleap.close();
    if (currentUser) {
      try {
        const user = (await getDocDataById(
          "user",
          override_id || currentUser.uid
        )) as any as User;
        if (!user) {
          console.error("user not found ");
          if (isinside) {
            navigateWorkspace("/login", orgData);
          }

          return;
        } else if (isinsideportal && !isImpPortal()) {
          let actualpage = location.pathname;
          //await handleLogout(actualpage);
          console.warn("user exists within portal, logging out");
          console.warn("loggin out CANCELED");
          return;
        }

        const org = (await getOrgById(user.org_id)) as any as Org; // Récupère l'organisation par référence
        if (!org) {
          navigateWorkspace("/setup", orgData);
          console.error("org not found");
          return;
        }
        await fetchCarnets(org);

        const workspaces = (await getArrayDocDataByRef(
          org.workspaces_id || []
        )) as any as Workspace[];
        setWorkspaces(workspaces);

        if (workspaceId() && workspaceId() != "myself") {
          const workspace = (await getDocDataById(
            "workspace",
            workspaceId()
          )) as any as Workspace;
          if (!workspace) {
            console.error("workspace not found");
            navigateWorkspace("/login");
            return;
          }
          if (workspace.partner_id !== org.id) {
            // i should not be in this workspace
            if (isLight(org) && org.workspaces_id.length > 0) {
              // redirect to first workspace
              console.warn(
                "not partner of workspace, redirecting to first workspace"
              );
              navigateWorkspace("/home", orgData, org.workspaces_id[0]);
            } else {
              // redirect my own workspace
              console.warn(
                "not partner of workspace, redirecting to my workspace"
              );
              navigateWorkspace("/home", orgData, "myself");
            }
            setOrgData(org);

            setUserData(user);
            setWorkspaceData(null);
            return;
          }

          const master = (await getOrgById(workspace.master_id)) as any as Org;
          setUpdateListeners({
            user_id: user.id,
            org_id: org.id,
            master_id: master.id,
          });
          setWorkspaceData(workspace);
          setMasterData(master);
        } else if (isLight(org)) {
          console.log("no workspace id, using first workspace");
          if (!org.workspaces_id || org.workspaces_id.length === 0) {
            console.error("no workspaces found for org", org);
            logoutUser();
            return;
          }
          const workspace = (await getDocDataById(
            "workspace",
            org.workspaces_id[0]
          )) as any as Workspace;
          const master = (await getOrgById(workspace.master_id)) as any as Org;

          setMasterData(master);

          setWorkspaceData(workspace);

          if (workspaceId() === "myself") {
            navigateWorkspace("/home", orgData, workspace.id);
          }

          setUpdateListeners({
            user_id: user.id,
            org_id: org.id,
            master_id: workspace.master_id,
          });
        } else {
          console.log("no workspace id or in myself mode");
          setWorkspaceData(null);
          setMasterData(org);
        }

        setOrgData(org);

        setUserData(user);

        console.log("userData", user);
        setUpdateListeners({
          user_id: user.id,
          org_id: org.id,
          master_id: org.id,
        });
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );
      }
    }
  };
  useEffect(() => {
    if (!currentUser && !loading && !isAuthenticatingWithToken) {
      // User is not authenticated and not currently authenticating
      if (isinside) {
        console.log("❌ Not logged in, redirecting to /login");
        navigate("/login");
      }
    }

    if (currentUser) {
      console.log("✅ User authenticated, fetching data...");
      handleFetchData(currentUser, overrideId() ?? null);

      // If we just authenticated with authToken, navigate to the stored destination
      if (authTokenDestination && isAuthenticatingWithToken) {
        console.log("🎯 Navigating to stored destination:", authTokenDestination);
        navigate(authTokenDestination);
        setAuthTokenDestination(null);
        setIsAuthenticatingWithToken(false);
      }
      // Otherwise, if user is on login/entree page, redirect to home
      else if (location.pathname === "/login" || location.pathname === "/entree") {
        console.log("🏠 Redirecting authenticated user to /home");
        navigate("/home");
      }
    }
  }, [currentUser, loading, overrideId(), isAuthenticatingWithToken, authTokenDestination]);

  const unsubscribeUserData = useRef<any>(null);
  const unsubscribeOrgData = useRef<any>(null);
  const unsubscribeMasterData = useRef<any>(null);

  const [updateListeners, setUpdateListeners] = useState<any>({});
  const reconnectAttempts = useRef(0);
  const ws = useRef<WebSocket | null>(null);
  const currentUserDataRef = useRef(userData);
  useEffect(() => {
    currentUserDataRef.current = userData;
  }, [userData]);

  const maintenance_websocket_ref = useRef<boolean | undefined>(undefined);

  useEffect(() => {
    maintenance_websocket_ref.current = false;
  }, []);

  const handleSetMaintenanceWebsoket = async (value: any) => {
    maintenance_websocket_ref.current = value.websocket_active;
  };
  // start with current = false
  const unsubscribeMaintenanceWebsocket = useRef<(() => void) | null>(null);

  useEffect(() => {
    listenDocDataByIdX(
      "maintenance",
      "main",
      handleSetMaintenanceWebsoket,
      unsubscribeMaintenanceWebsocket
    );
    return () => {
      if (unsubscribeMaintenanceWebsocket.current) {
        unsubscribeMaintenanceWebsocket.current();
      }
    };
  }, []);

  const tryReconnect = useRef(false);
  const reconnectTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!userData || maintenance_websocket_ref.current === false) {
      return;
    }
    if (appState.dev) {
      return;
    }

    const connect = () => {
      if (appState.dev) {
        return;
      }
      if (ws.current) {
        console.warn("🛑 WebSocket already exists, skipping new connection.");
        return;
      }

      const user = currentUserDataRef.current;
      const url = `${wsprefix}ws/online/${user?.id}`;
      console.log("🔌 Connecting WebSocket to", url);

      const socket = new WebSocket(url);
      ws.current = socket;

      socket.onopen = () => {
        if (user) {
          console.log("✅ WebSocket connected user", user.id);
        } else {
          console.log("✅ WebSocket connected, but user is null");
        }
      };

      socket.onclose = () => {
        console.log("❌ WebSocket disconnected");

        ws.current = null; // Clean up so we know it’s gone

        retryConnection();
      };

      socket.onerror = (e) => {
        console.error("❌ WebSocket error", e);
        socket.close(); // Trigger onclose
      };
    };

    const retryConnection = () => {
      const delay = Math.min(60000, 1000 * 2 ** reconnectAttempts.current); // Cap at 60s
      console.log(`⏳ Reconnecting in ${delay / 1000}s...`);
      reconnectAttempts.current += 1;

      reconnectTimeout.current = setTimeout(() => {
        connect();
      }, delay);
    };

    connect();

    return () => {
      console.log("❌ Cleaning up WebSocket");
      if (ws.current) {
        ws.current.close();
        ws.current = null;
      }
      if (reconnectTimeout.current) {
        clearTimeout(reconnectTimeout.current);
      }
    };
  }, [userData?.id, maintenance_websocket_ref]);

  useEffect(() => {
    // updateListeners is an array of functions that will be called when the orgData is updated
    if (updateListeners.user_id) {
      listenDocDataByIdX(
        "user",
        updateListeners.user_id,
        handleSetUserData,
        unsubscribeUserData
      );
    }

    if (updateListeners.org_id) {
      listenDocDataByIdX(
        "org",
        updateListeners.org_id,
        handleSetOrgData,
        unsubscribeOrgData
      );
    }
    if (updateListeners.master_id) {
      listenDocDataByIdX(
        "org",
        updateListeners.master_id,
        handleSetMasterData,
        unsubscribeMasterData
      );
    }

    return () => {
      if (unsubscribeUserData.current) {
        unsubscribeUserData.current();
      }
      if (unsubscribeOrgData.current) {
        unsubscribeOrgData.current();
      }
      if (unsubscribeMasterData.current) {
        unsubscribeMasterData.current();
      }
    };
  }, [updateListeners]);

  const handleLogout = async (goback_url?: string | null) => {
    try {
      console.warn("handleLogout");
      Gleap.clearIdentity();
      Gleap.close();

      resetAppStateLogin();
      const adminToken = localStorage.getItem("lastToken");

      if (adminToken) {
        const adminId = localStorage.getItem("lastId");
        localStorage.removeItem("lastId");
        localStorage.removeItem("lastToken");
        const token = await loginAs(adminId, adminToken, prefix);
        await signInWithCustomToken(auth, token);
        navigateWorkspace("/home");
        await logoutUser();
      } else {
        await logoutUser();
        if (goback_url) {
          navigateWorkspace(goback_url);
        } else {
          console.log("No goback_url provided, navigating to login");
          navigateWorkspace("/login"); // Navigate to "entree" after logout
        }
      }
      setUpdateListeners({});
      setUserData(null);
      setOrgData(null);
    } catch (error: any) {
      console.error("Error logging out:", error.message);
    }
  };

  const handleLoginAs = async (id: string) => {
    Gleap.clearIdentity();
    setUserData(null);
    setOrgData(null);
    setUpdateListeners({});

    try {
      if (!id || !currentUser) {
        console.error("Invalid user id");
        return;
      }
      // Sign out the current user before switching
      const user = currentUser as FirebaseUser;
      const token = await user.getIdToken(); // Fetch token from Firebase

      const switch_token = await loginAs(id, token, prefix);

      // Sign in with the custom token
      await signInWithCustomToken(auth, switch_token);

      // Wait until the currentUser is available
      let refreshedUser: FirebaseUser | null = null;
      for (let i = 0; i < 10; i++) {
        refreshedUser = auth.currentUser;
        if (refreshedUser) break;
        await new Promise((resolve) => setTimeout(resolve, 200)); // wait 200ms
      }

      if (!refreshedUser) {
        throw new Error("Failed to retrieve the current user after login.");
      }
      // Fetch user data based on currentUser uid
      const userData = (await getDocDataById(
        "user",
        refreshedUser.uid
      )) as any as User;
      if (!userData || !userData.org_id) {
        throw new Error("Invalid user data or missing org_id.");
      }

      // Fetch org data
      const orgData = (await getOrgById(userData.org_id)) as any as Org;

      navigateWorkspace("/home", orgData); // Navigate to a protected route after successful login
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const navigateWorkspace = (
    path: string,
    newOrg?: Org | undefined | null,
    workspace_id?: string | undefined | null
  ) => {
    navigate(path)
    return
    // if (path === "-1") {
    //   navigate(-1);
    //   return;
    // }
    // let org = newOrg || orgData;
    // console.log("navigateWorkspace", path, org);
    // if (path === "abort_override") {
    //   navigate("/home");
    //   return;
    // }
    // if (["/login", "/login-partner", "/signin", "/entree"].includes(path)) {
    //   navigate(path);
    //   return;
    // }
    // if (path.includes("/folders")) {
    //   //fetchFolders();
    // }
    // if (
    //   (org?.type === "master" && overrideId() === null && !isImpPortal()) ||
    //   path.includes("/imp/") ||
    //   path.includes("/imp-portal/")
    // ) {
    //   navigate(path);
    // } else {
    //   if (workspaceId()) {
    //     if (overrideId()) {
    //       navigate(
    //         "/imp/" +
    //           overrideId() +
    //           "/workspace/" +
    //           (workspace_id || workspaceId()) +
    //           path
    //       );
    //     } else {
    //       navigate("/workspace/" + (workspace_id || workspaceId()) + path);
    //     }
    //   } else {
    //     if (org && org.workspaces_id?.length > 0) {
    //       if (overrideId()) {
    //         navigate(
    //           "/imp/" +
    //             overrideId() +
    //             "/workspace/" +
    //             (workspace_id || workspaceId() || org.workspaces_id[0]) +
    //             path
    //         );
    //       } else {
    //         navigate(
    //           "/workspace/" +
    //             (workspace_id || workspaceId() || org.workspaces_id[0]) +
    //             path
    //         );
    //       }
    //     } else if (isImpPortal()) {
    //       path = path.replace("/imp-portal", "/");
    //       path = "/imp-portal" + path;
    //       navigate(path);
    //     } else {
    //       navigate(path);
    //     }
    //   }
    // }
  };

  function isOverriding() {
    return location.pathname.includes("/imp/");
  }

  function isImpPortal() {
    return location.pathname.includes("/imp-portal/");
  }

  function overrideId() {
    // find the workspace id from the URL
    const path = location.pathname.split("/");
    const workspaceIndex = path.indexOf("imp");
    if (workspaceIndex !== -1) {
      return path[workspaceIndex + 1];
    } else {
      return undefined;
    }
  }

  function workspaceId() {
    // find the workspace id from the URL
    const path = location.pathname.split("/");
    const workspaceIndex = path.indexOf("workspace");
    if (workspaceIndex !== -1) {
      return path[workspaceIndex + 1];
    } else {
      return null;
    }
  }

  const [client_notify, setClientNotify] = useState(true);

  const handleSetMaintenanceCaution = async (value: any) => {
    let current_page = "";
    if (isinside && value.ison && current_page !== "login") {
      if (currentUser) {
        let user = (await getDocDataById(
          "user",
          (currentUser as FirebaseUser).uid
        )) as any as User;
        if (user && user.maintenance_proof) {
        } else {
          navigateWorkspace("/entree");
        }
      }
    }
  };
  const [maintenance_chill, setMaintenanceChill] = useState(null);
  const [maintenance_status, setMaintenanceStatus] = useState(null);

  const handleSetMaintenanceChill = async (value: any) => {
    setMaintenanceChill(value);
  };
  const handleSetMaintenanceStatus = async (value: any) => {
    setMaintenanceStatus(value);
  };

  const [version, setVersion] = useState<string | null>(null);
  const [messageNewVersion, setMessageNewVersion] = useState(false);
  useEffect(() => {
    fetch("/version.txt")
      .then((response) => response.text())
      .then((text) => setVersion(text))
      .catch((error) => console.error("Error fetching version:", error));
  }, []);

  const [loadingVersion, setLoadingVersion] = useState(false);

  const isProd = !window.location.href.includes("localhost");

  const handleSetVersion = (value: any) => {
    const LOCAL_VERSION = version || 5;
    if (LOCAL_VERSION !== value.logement_react_version.toString()) {
      // value.logement_react_version is a number
    } else {
    }
    console.log("LOCAL_VERSION", LOCAL_VERSION);
    console.log(
      "value.logement_react_version.toString()",
      value.logement_react_version.toString()
    );

    if (!isProd) {
      return;
    }

    if (isNaN(value.logement_react_version)) {
      // should not happen
      sendErrorDiscord("VERSION IS NOT A NUMBER", prefix);
      return;
    }
    if (value.logement_react_version > LOCAL_VERSION) {
      handleClickVariant("Nouvelle version disponible", "success");
      setMessageNewVersion(true);
      setLoadingVersion(false);
    }
  };

  const unsubscribeMaintenance = useRef<(() => void) | null>(null);
  const unsubscribeMaintenanceChill = useRef<(() => void) | null>(null);
  const unsubscribeMaintenanceStatus = useRef<(() => void) | null>(null);

  const unsubscribeVersion = useRef<(() => void) | null>(null);

  const handleInitiate = async (version: any) => {
    if (version) {
      let version2 = await getDocDataById("maintenance", "version");
      handleSetVersion(version2);
      console.log("version2", version2);
    }
  };

  useEffect(() => {
    handleInitiate(version);

    listenDocDataByIdX(
      "maintenance",
      "jFEkxuHCrri7KHy9WaFU",
      handleSetMaintenanceCaution,
      unsubscribeMaintenance
    );

    listenDocDataByIdX(
      "maintenance",
      "feXLghrFEHIXxEroBrSl",
      handleSetMaintenanceChill,
      unsubscribeMaintenanceChill
    );

    listenDocDataByIdX(
      "maintenance",
      "status",
      handleSetMaintenanceStatus,
      unsubscribeMaintenanceStatus
    );

    listenDocDataByIdX(
      "maintenance",
      "main",
      handleSetMaintenanceWebsoket,
      unsubscribeMaintenanceWebsocket
    );

    listenDocDataByIdX(
      "maintenance",
      "version",
      handleSetVersion,
      unsubscribeVersion
    );

    return () => {
      if (unsubscribeMaintenance.current) {
        unsubscribeMaintenance.current();
      }
      if (unsubscribeMaintenanceChill.current) {
        unsubscribeMaintenanceChill.current();
      }
      if (unsubscribeMaintenanceStatus.current) {
        unsubscribeMaintenanceStatus.current();
      }
      if (unsubscribeMaintenanceWebsocket.current) {
        unsubscribeMaintenanceWebsocket.current();
      }
      if (unsubscribeVersion.current) {
        unsubscribeVersion.current();
      }
    };
  }, [version, currentUser]);

  let iframe = false;

  return (
    <div
      className={`bg-transparent w-full h-screen  flex flex-col ${
        iframe ? "pointer-events-none" : "pointer-events-auto"
      }`}
    >
      {isOverriding() && (
        <div className=" w-screen pointer-events-auto bg-red-500 text-h1 font-semibold text-white px-3 py-3 flex flex-row justify-between">
          Vous êtes sur le compte de votre partenaire
          <SecondaryButton
            onClick={() => {
              navigateWorkspace("abort_override", null, null);
            }}
          >
            Retourner sur mon compte
          </SecondaryButton>
        </div>
      )}
      {isImpPortal() && (
        <div className=" w-screen pointer-events-auto bg-red-500 text-h1 font-semibold text-white px-3 py-3 flex flex-row justify-between">
          Vous êtes sur la vue du particulier
          <SecondaryButton
            onClick={() => {
              navigateWorkspace("abort_override", null, null);
            }}
          >
            Retourner sur mon compte
          </SecondaryButton>
        </div>
      )}

      <div
        className={`
        ${
          location.pathname.includes("/planning")
            ? "bg-neutral-200"
            : location.pathname.includes("iframe")
            ? "bg-transparent"
            : "bg-white"
        }
         w-full h-full  flex sm:flex-row flex-col `}
      >
        <div
          id="MyDiv"
          className="flex h-full w-full items-stretch   flex-grow sm:flex-row  bg-transparent"
        >
          {messageNewVersion && isProd && !iframe && (
            <div
              onClick={() => {
                window.location.reload();
              }}
              className="fixed hover:-translate-y-1     hover:scale-105  transition-all duration-300 pointer-events-auto flex items-center justify-center bottom-10 p-1 min-w-fit left-1/2 -translate-x-1/2 z-30 flex-col gap-1 text-white h-fit w-fit bg-indigo-500 shadow-lg rounded-xl cursor-pointer"
            >
              <div className="absolute -z-10  top-0 right-0 h-full w-full  rounded-xl">
                <img
                  src="https://products.ls.graphics/mesh-gradients/images/87.-Spacy.jpg"
                  className="w-full h-full rounded-xl"
                />
              </div>
              <div className="px-8 py-4  bg-black rounded-xl z-10 flex flex-col gap-1">
                <div className="flex flex-row gap-10 items-center">
                  <div className="flex flex-col gap-2 ">
                    <div className="font-semibold">
                      Une nouvelle version est disponible sur le site.
                    </div>{" "}
                    <div className="">
                      Veuillez cliquez ici pour passer à la nouvelle version.
                    </div>
                  </div>{" "}
                  <div className="">
                    <Icon1 fill="white" icon_name="hexagone2" size={30}></Icon1>
                  </div>
                </div>
              </div>
            </div>
          )}
          {isinside && userData && orgData && masterData && (
            <div
              className={` flex-col flex min-w-fit h-full ${
                overrideId() ? "max-h-[95vh]" : ""
              } overflow-auto bg-transparent `}
            >
              <NavBar
                actualpage={actualpage}
                local_version={version as string}
                orgData={orgData}
                masterData={masterData}
                userData={userData}
                override_id={overrideId()}
                navigateWorkspace={navigateWorkspace}
                handleLogout={handleLogout}
                handleLoginAs={handleLoginAs}
                workspaceData={workspaceData}
              />
            </div>
          )}

          {isinside && isinparameters && (
            <ParametersNavBar
              actualpage={actualpage}
              override_id={overrideId() as any}
              navigateWorkspace={navigateWorkspace}
              orgData={orgData}
              userData={userData}
            />
          )}

          <div className="flex flex-col w-full h-full bg-transparent ">
            <Suspense fallback={<div></div>}>
              <Routes>
                <Route
                  path="*"
                  element={
                    <RoutesManager
                      userData={userData}
                      handleLogout={handleLogout}
                      navigateWorkspace={navigateWorkspace}
                      orgData={orgData}
                      workspaceData={workspaceData}
                      handleLoginAs={handleLoginAs}
                      handleClickVariant={handleClickVariant}
                    />
                  }
                />
              </Routes>
            </Suspense>
          </div>
        </div>{" "}
      </div>
    </div>
  );
};

export default App;
